var lib_core = require("lib-core");
var lib_geometry = require("lib-geometry");
var editor_2d = require("editor-2d");
var ui_extensions = require("ui-extensions");
var cio_config = require("cio-config");

var ArcCenterHandleModel = function (initialCoord) {
    var self = this;
    this.makeObservableTreeNode();

    this.coord = this.value("coord", true);
    this.selected = this.value("interactionSelected", true);

    this.coord(initialCoord);

    this.otherHandleModel1 = null;
    this.otherHandleModel2 = null;

    this.selected.onChange("selected_infocus", function (value) {
        if (self.isAlive() && self.pathInteractionModel.isAlive()) {
            self.pathInteractionModel.infocus(value);
            self.segmentModel.infocus(value);
        }
    }, 10);

    this.onInit("initialize", this.initialize, 10);
};
lib_core.mixin(ArcCenterHandleModel, lib_core.ObservableTreeNode);
ArcCenterHandleModel.$class = "ArcCenterHandleModel";
module.exports = ArcCenterHandleModel;

ArcCenterHandleModel.prototype.initialize = function() {
    var self = this;
    this.segmentModel = this.parent();
    this.pathInteractionModel = this.segmentModel.parent();

    //Shadows for inspector
    this.origin = this.segmentModel.origin;

    if (this.origin) {
        this.showX = this.shadow("showX",
            function () {
                return self.coord().getX();
            },
            null,
            [this.coord]
        );

        this.showY = this.shadow("showY",
            function () {
                return self.coord().getY();
            },
            null,
            [this.coord]
        );
    }
};

ArcCenterHandleModel.prototype.move = function (vec) {
    var self = this;
    this.segmentModel.movingHandle(true);
    var new_center;
    var new_focal;
    if(this.segmentModel.isCircular()) {    //keep circular
        var prev = this.segmentModel.prev_handle;
        var next = this.segmentModel.next_handle;
        var middle = next.coord().add(prev.coord()).mult(1.0/2.0);
        var bisect_dir = next.coord().sub(prev.coord()).perp();
        var bisect_line = new lib_geometry.Line(bisect_dir, middle);
        new_center = this.coord().add(vec);
        new_center = bisect_line.closestPointToPoint(new_center);
        new_focal = new_center;
    } else {
        new_center = this.coord().add(vec);
        new_focal = this.otherHandleModel1.coord();
    }
    self.segmentModel.setApproximateCandF(new_center, new_focal);
    this.segmentModel.movingHandle(false);
};

ArcCenterHandleModel.prototype.getSnapSet = function () {
    var self = this;
    var result = new editor_2d.SnapSet();
    result.add(self.coord(), 1, 0, null, this, 0, null);
    return result;
};

ArcCenterHandleModel.prototype.setSelected = function (selected) {
    this.selected(selected);
};

ArcCenterHandleModel.prototype.getInspectorElements = function () {
    var inspector_elements = this.parent().getInspectorElements();

    var gridUnit = this.parent().origin.grid_unit().replace('u','\u03BC');

    inspector_elements.input_elements.push(
        {
            label       : 'Center X',
            type        : ui_extensions.InspectorInputType.VALUE_AND_FIXEDUNIT,
            datamember  : this.showX,
            datatype    : cio_config.types.float,
            unit        : gridUnit,
            read_only   : true
        },
        {
            label       : 'Center Y',
            type        : ui_extensions.InspectorInputType.VALUE_AND_FIXEDUNIT,
            datamember  : this.showY,
            datatype    : cio_config.types.float,
            unit        : gridUnit,
            read_only   : true
        }
    );

    inspector_elements.help_elements['name'] = 'Arc Center Point';
    return inspector_elements;
};

ArcCenterHandleModel.prototype.doubleClickAction = function (coord, subelement) {
    var prev = this.segmentModel.prev_handle;
    var next = this.segmentModel.next_handle;

    if(this.segmentModel.isCircular()) {//make ellipse
        var offset = prev.coord().sub(next.coord()).mult(1/4);
        this.segmentModel.setApproximateCandF(this.coord(), this.coord().add(offset));
    } else {    //make circle
        var middle = next.coord().add(prev.coord()).mult(1.0/2.0);
        var bisect_dir = next.coord().sub(prev.coord()).perp();
        var bisect_line = new lib_geometry.Line(bisect_dir, middle);
        var new_center = bisect_line.closestPointToPoint(this.coord());
        this.segmentModel.setApproximateCandF(new_center, new_center);
    }
};
